import type { CustomAxiosInstance } from './axios/IUseAxios'
import axios from 'axios'
import { createAxiosConfig } from './axios/config'
import { setupRequestInterceptors, setupResponseInterceptors } from './axios/interceptors'

/**
 * Create and configure Axios instance
 */
const createAxiosInstance = (): CustomAxiosInstance => {
    const axiosInstance = axios.create(createAxiosConfig()) as CustomAxiosInstance

    setupRequestInterceptors(axiosInstance)
    setupResponseInterceptors(axiosInstance)

    return axiosInstance
}

/**
 * Global Axios instance
 */
const useAxios = createAxiosInstance()

export default useAxios
